<script setup lang="ts">
import tenkoAssociationType from "@/types/responses/getIttenkoAssociation";
import DeleteIcon from "@/components/TenkoAssociations/DeleteIcon.vue";
import EditIcon from "@/components/TenkoAssociations/EditIcon.vue";
import DisplayFullnameFromUpdatedBy from '@/components/Common/DisplayFullnameFromUpdatedBy.vue';
import { formatDateTime } from "@/services/functions";
import accountType from "@/types/account";
import { computed } from 'vue';
import i18n from '@/lang/i18n';

const emits = defineEmits(['openUpdateModal', 'openDeleteModal']);
const props = defineProps<{
  tenkoAssociations: tenkoAssociationType[];
  account: accountType;
  isUpdateAuthority: boolean;
  isDeleteAuthority: boolean;
}>();

const searchTenkoAssociation = computed(() => {
  return props.tenkoAssociations.find((tenkoAssociation) => {
    return tenkoAssociation.operation_office_id === props.account.officeable_id
      && tenkoAssociation.driver_id === props.account.driver_id;
  });
})

function employeeCode() {
  const tenkoAssociation = searchTenkoAssociation.value;
  if (tenkoAssociation) {
    return tenkoAssociation.employee_cd;
  }
  const driverId = String(props.account.driver_id);
  return driverId.padStart(10,"0")
}

function updatedAt() {
  const tenkoAssociation = searchTenkoAssociation.value;
  const updatedOrCreatedAt = tenkoAssociation?.updated_at ?? tenkoAssociation?.created_at;

  if (tenkoAssociation && updatedOrCreatedAt) {
    return formatDateTime(new Date(updatedOrCreatedAt));
  }
  return i18n.global.t('common.notApplicable');
}

function openUpdateModal(account: accountType, employeeCd: string) {
  return emits('openUpdateModal', account, employeeCd, !!searchTenkoAssociation.value)
}

function openDeleteModal(tenkoAssociation: tenkoAssociationType) {
  return emits('openDeleteModal', tenkoAssociation)
}
</script>
<template>
  <td>
    {{ account.id }}
  </td>
  <td>
    {{ account.full_name }}
  </td>
  <td>
    {{ account.email }}
  </td>
  <td>
    {{ account.officeable.operation_office_name }}
  </td>
  <td>
    {{ account.department_target_name }}
  </td>
  <td>
    {{ account.driver_id }}
  </td>
  <td>
    {{ employeeCode() }}
  </td>
  <td>
    {{ updatedAt() }}
  </td>
  <td>
    <DisplayFullnameFromUpdatedBy
      :updatedBy="searchTenkoAssociation?.updated_by ?? null"
    />
  </td>
  <td>
    <EditIcon
      v-if="props.isUpdateAuthority"
      :account="account"
      :employeeCode="employeeCode()"
      @openUpdateModal="openUpdateModal"
    />
  </td>
  <td>
    <DeleteIcon
      v-if="props.isDeleteAuthority"
      :tenkoAssociation="searchTenkoAssociation"
      @openDeleteModal="openDeleteModal"
    />
  </td>
</template>
